import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { secondary } = theme.palette;

  return {
    tableTitle: {
      display: "flex",
      alignItems: "center",
      height: 40,
      fontSize: 13,
      color: secondary.dark,
      textTransform: "capitalize",
      marginBottom: 3
    }
  };
});
